const Vendor = {

    // FIELDS
    "vendor": "Vendor",
    "name": "Name",
    "description": "Description",
    "contact": "Contact",
    "email": "Email",
    "address": "Address",
    "status": "Status",
    "search": "Search",
    
    // PAGE HEADER
    "list_title": "Vendor",
    "filter_title": "Vendor Filter",
    
    // TABLE HEADER
    "table_name": "Name",
    "table_contact": "Contact",
    "table_email": "Email",
    "table_description": "Description",
    
    // ERROR
    "error_name": "Enter Vendor Name",
    "error_description": "Enter Description",
    "error_contact": "Enter Contact",
    "error_email": "Enter Email",
    "error_address": "Enter Address",
    "error_status": "Select Status",

}

export default Vendor;

